<template>
    <div>
        <div class="tdx-title">历年院校投档线</div>
        <div class="tdx-condition">
            <el-form :inline="true" ref="tdxFormRef">
                <el-form-item label="选择批次">
                    <el-select style="width:150px;" v-model="tdxParam.pc" clearable>
                    <el-option v-if="pcList.length===0" disabled value="-1">
                        <i class="el-icon-loading"  style="font-size: 16px;"></i>
                    </el-option>
                    <template v-if="pcList.length>0">
                        <el-option v-for="(item,index) in pcList"
                    :key="index" :label="item.name" :value="item.value">
                        </el-option>
                    </template>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择年度" prop="">
                    <el-select style="width:150px;" v-model="tdxParam.nd" clearable>
                        <el-option v-if="ndList.length===0" disabled value="-1">
                            <i class="el-icon-loading"  style="font-size: 16px;"></i>
                        </el-option>
                        <template v-if="ndList.length>0">
                        <el-option v-for="(item,index) in ndList"
                        :key="index" :label="item.name" :value="item.value">
                    </el-option>
                        </template>
                    </el-select>
                </el-form-item>
                <el-form-item label="院校名称">
                    <el-input style="width:150px;" v-model.trim="tdxParam.yxmc"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getTdx">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div id="tdx-data">
            <el-table border :data="tdxList" height="455"
            :header-cell-style="{'background-color':'#B0E2FF',
            'color': '#3B3B3B','border':'1px solid #0099FF','text-align':'center'}"
            :cell-style="{'border':'1px solid #0099FF','text-align':'center'}" size="small">
                <el-table-column show-overflow-tooltip label="年度" prop="nd" width="100" :resizable="false"></el-table-column>
                <el-table-column show-overflow-tooltip label="院校代号" prop="sb" width="100" :resizable="false"></el-table-column>
                <el-table-column show-overflow-tooltip label="院校名称" width="280" prop="yxmc" :resizable="false"></el-table-column>
                <el-table-column label="首选科目" prop="kl" width="100" :resizable="false">
                    <template slot-scope="scope">
                        <span v-if="scope.row.kl===1">历史</span>
                        <span v-if="scope.row.kl===2">物理</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="批次" prop="pc" width="80" :resizable="false">
                    <template slot-scope="scope">
                        <span v-if="scope.row.pc===6">本科批</span>
                        <span v-if="scope.row.pc===7">专科批</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="专业组" prop="zyz" width="140" :resizable="false">
                    <template slot-scope="scope">
                        <div style="display: flex;align-items: center;">
                            <router-link
                                tag="a"
                                target="_blank"
                                :to="{
                                    path: '/main/tdxToZyzDetail',
                                    query: { gbdm: scope.row.gbdm, zyz: scope.row.zyz,pc:scope.row.pc,yxmc:scope.row.yxmc,yxxh:scope.row.yxxh }
                                }" style="color: rgb(33, 134, 222);">[{{ scope.row.zyz }}]</router-link>
                            <el-button type="primary" size="small" style="margin-left: 10px;"
                            @click="clickShowZyDialog(scope.row)">查看专业</el-button>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="投档线" prop="tdx" width="90" :resizable="false">
                </el-table-column>
                <el-table-column show-overflow-tooltip label="控制线" prop="kzfs" width="100" :resizable="false"></el-table-column>
                <el-table-column show-overflow-tooltip label="线差" width="100" :resizable="false">
                    <template slot-scope="scope">
                        <span v-if="scope.row.tdx>0&&scope.row.kzfs>0">{{scope.row.tdx-scope.row.kzfs}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div v-if="tdxFlag" class="tdx-page">
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tdxParam.pageNum"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="tdxParam.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tdxTotal">
            </el-pagination>
            </div>
            <el-dialog :visible.sync="zyzCheckzyVisible"
            :title="'查看专业'"
            width="30%"
            @close="closeZyDialog">
                <div style="border: 1px solid #d9d9d9;height: 344px;border-radius: 4px;
                                overflow: hidden;background: #FFF;box-sizing: border-box;
                                position: relative; vertical-align: middle;">
                    <div class="h" style="padding: 9px 0px 9px 19px;border-bottom: 1px solid #e8e8e8;">
                        <div>
                            <span style="color: blue;font-weight: 700;">{{ dialogYxmc }}</span>
                            {{ dialogZyz }}组共有{{ dialogZyCount }}个专业</div>
                        <div></div>
                    </div>
                    <a-table
                    :data-source="zyData" :columns="zyColunms"
                        size="small"
                        :showHeader="false"
                        :locale="{filterConfirm: '确定',
                                    filterReset: '重置',
                                    emptyText: '暂无数据'}"
                                    :rowKey="(record)=>record.zymc"
                        bordered :pagination="false" :scroll="{'y':300}"></a-table>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import {mapState} from 'vuex';
export default {
data(){
    return{
        tdxList:[],
        tdxParam:{
            nd:"",
            pc:"",
            yxmc:"",
            kl:"",
            pageNum:1,
            pageSize:10
        },
        pcList:[
        ],
        rules:{
            pc:[
                {required:true,message:"请输入",trigger:"change"}
            ],
            nd:[
                {required:true,message:"请输入",trigger:"blur"}
            ]
        },
        tdxFlag:true,
        tdxTotal:0,
        zyzCheckzyVisible:false,
        dialogYxmc:'',
        dialogZyz:'',
        dialogZyCount:0,
        zyData:[],
        zyColunms:[
            {
                            dataIndex: 'zymc',
                            title: '专业',
                            ellipsis:true,
                            align:'center'
            },
        ],
        ndList:[]
    };
},
methods:{
    async getTdx(){
        // this.$refs.tdxFormRef.validate(validate=>{
        //     if(validate){
        //     }else{
        //         return false;
        //     }
        // });
        this.loadData();
    },
    closeZyDialog(){
        this.zyzCheckzyVisible=false;
    },
   async loadData(pageNum=1,pageSize=10){
        this.tdxFlag=false;
        const loading=this.$loading({fullscreen:true,target:document.getElementById("tdx-data"),text:"正在加载中"});
        this.tdxParam.pageNum=pageNum;
        this.tdxParam.pageSize=pageSize;
        const res=await this.$http.postHttp("/lnsj/tdx",this.tdxParam);
        console.log(res);
        if(res.data.code===200){
            const data=[...res.data.obj.records];
            for(let i=0;i<data.length;i++){
                if(data[i].zymcs){
                    const arr=data[i].zymcs.split(",");
                    data[i].zyData=[];
                    for(let j=0;j<arr.length;j++){
                        data[i].zyData.push({zymc:arr[j]});
                    }
                }
            }
            this.tdxList=data;
            this.tdxTotal=res.data.obj.total;
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:"error"});
            }else if(res.data.msg){
                this.$message({message:res.data.msg,type:"error"});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        loading.close();
        this.tdxFlag=true;
    },
    async getPcCondition(){
        const res=await this.$http.getHttp("/lnsj/tdxpcs");
        if(res.data.code===200){
            const pcs=res.data.obj;
            for(let i=0;i<pcs.length;i++){
                if(pcs[i].pcmc){
                    this.pcList[i]={};
                    this.pcList[i].name=pcs[i].pcmc;
                    this.pcList[i].value=pcs[i].pc+"";
                }
            }
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:"error"});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
    },
    async handleSizeChange(pageSize){
        await this.loadData(1,pageSize);
    },
    async handleCurrentChange(pageNum){
        await this.loadData(pageNum,10);
    },
    clickShowZyDialog(row){
        this.dialogYxmc=row.yxmc;
        this.dialogZyz=row.zyz;
        this.dialogZyCount=row.zyData&&row.zyData.length>0?row.zyData.length:0;
        this.zyData=row.zyData&&row.zyData.length>0?row.zyData:[];
        this.zyzCheckzyVisible=true;
    },
    async getNdConditon(){
        const res=await this.$http.getHttp("/lnsj/tdxNds");
        if(res.data.code===200){
            const nds=res.data.obj;
            const ndArr=[];
            for(let i=0;i<nds.length;i++){
                ndArr.push({name:nds[i],value:nds[i]+""});
            }
            this.ndList=ndArr;
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:"error"});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
    }
},
computed:{
    ...mapState(["userInfo"])
},
async mounted(){
    this.tdxParam.kl=this.userInfo.sxkm;
    await this.getTdx();
    await this.getPcCondition();
    await this.getNdConditon();
}
};
</script>
<style lang="less" scoped>
.tdx-title{
    width:1100px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px auto;
    font-size: 18px;
    font-weight: bold;
}
.tdx-page{
    width:800px;
    margin:20px auto;
}
</style>
